// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorCoverageMedicalCoverageMedicalCoverageResponse {
    static getAttributeTypeMap() {
        return PayorCoverageMedicalCoverageMedicalCoverageResponse.attributeTypeMap;
    }
}
PayorCoverageMedicalCoverageMedicalCoverageResponse.discriminator = undefined;
PayorCoverageMedicalCoverageMedicalCoverageResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "PayorAccountMedicalBenefitModels"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    }
];
//# sourceMappingURL=payorCoverageMedicalCoverageMedicalCoverageResponse.js.map